import React, {FC, FormEvent} from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {
  KeyboardArrowLeftSharp,
  KeyboardArrowRightSharp,
} from '@mui/icons-material'
import {Box, Button, MobileStepper} from '@mui/material'
import {Theme} from '@mui/material/styles'
import {makeStyles} from 'tss-react/mui'

import {useResponsive} from '@progyny/hooks/useResponsive'

type EventHandlerType = (event: FormEvent) => void

type StepperProps = {
  isDisabled?: boolean
  activeStep: number
  toContinuePath: EventHandlerType | string
  toCancelPath: string
  cancelButtonText?: string
}

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    zIndex: 2,
    background: theme.palette.other.brandColors.middleBlue,
    flexGrow: 1,
  },
  dotActive: {
    background: theme.palette.text.primary,
  },
}))

export const ReimbursementMobileStepper: FC<StepperProps> = (props) => {
  const {t} = useTranslation()
  const {
    isDisabled,
    activeStep,
    toContinuePath,
    toCancelPath,
    cancelButtonText = t('common_cancel'),
  } = props
  const {classes} = useStyles()
  const history = useHistory()
  const isDownSM = useResponsive('down', 'sm')

  const isFunction =
    typeof toCancelPath === 'function' || typeof toContinuePath === 'function'

  function goToPath(toPath: any) {
    if (!isDisabled && typeof toPath === 'function') {
      toPath()
    } else {
      return history.push(toPath)
    }
  }

  return (
    <>
      {isDownSM && (
        <MobileStepper
          variant={'dots'}
          steps={4}
          activeStep={activeStep}
          classes={{root: classes.root, dotActive: classes.dotActive}}
          backButton={
            <Box
              width={94}
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
            >
              <Button
                disableRipple
                onClick={() => goToPath(toCancelPath)}
                size={'small'}
              >
                <KeyboardArrowLeftSharp />
                {cancelButtonText}
              </Button>
            </Box>
          }
          nextButton={
            <Box
              width={94}
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
            >
              <Button
                disableRipple
                onClick={() => goToPath(toContinuePath)}
                size={'small'}
                disabled={isDisabled}
              >
                {isFunction ? t('common_submit') : t('common_next')}
                <KeyboardArrowRightSharp />
              </Button>
            </Box>
          }
        />
      )}
    </>
  )
}
